import { compareTwoArrayOfString } from "@/common/utils";
import { findUserAnswer } from "./quotes";

export const checkAndUpdateVisibility = (
  thisQuestion,
  otherQuestions,
  apiAnswers
) => {
  // Used when loading up a quote
  // Check if the visibility of thisQuestion is affected by an answer to any of the otherQuestions
  if (!thisQuestion.RelatedQuestionId || !thisQuestion.RelatedQuestionId.length)
    return thisQuestion.IsVisible;

  const relatedQuestion = otherQuestions.find((q) => {
    return q.Id === thisQuestion.RelatedQuestionId[0];
  });

  if (!relatedQuestion || !relatedQuestion.InterfaceKey)
    return thisQuestion.IsVisible;

  const relatedApiAnswer = findUserAnswer(apiAnswers, relatedQuestion);
  if (!relatedApiAnswer) return thisQuestion.IsVisible;

  if (!thisQuestion.Conditions || !thisQuestion.Conditions.length)
    return thisQuestion.IsVisible;

  // Make conditions strings uniformly lowercase
  const formattedConditions = thisQuestion.Conditions.map((c) =>
    c.toString().toLowerCase()
  );

  // Check if thisQuestion.Value matches a condition string
  thisQuestion.IsVisible = formattedConditions.includes(
    relatedApiAnswer.Value.toString().toLowerCase()
  );

  return thisQuestion.IsVisible;
};

export const updateVisibilityBasedOn = (
  thisQuestion,
  basedOnQuestion,
  allQuestions
) => {
  // Used when the value of basedOnQuestion changes
  // Check if thisQuestion is affected by that answer changing
  // (Usually called in a loop checking every "thisQuestion" sequentially)
  if (
    thisQuestion.RelatedQuestionId &&
    thisQuestion.RelatedQuestionId.includes(basedOnQuestion.Id) &&
    thisQuestion.Conditions &&
    thisQuestion.Conditions.length
  ) {
    // Make conditions strings uniformly lowercase
    const formattedConditions = thisQuestion.Conditions.map((c) =>
      c.toString().toLowerCase()
    );
    if (thisQuestion.RelatedQuestionId.length < 2) {
      // Check if thisQuestion.Value matches a condition string
      thisQuestion.IsVisible = formattedConditions.includes(
        basedOnQuestion.Value.toString().toLowerCase()
      );
    } else {
      const allQuestionsRelated = allQuestions.filter((item) => {
        return (
          item?.Value?.length > 0 &&
          thisQuestion.RelatedQuestionId.includes(item.Id)
        );
      });

      const allQuestionsRelatedValues = allQuestionsRelated.map(
        ({ Value }) => Value
      );

      //in case we need all conditions are matching
      if (thisQuestion.TypeOfCondition === "AND") {
        thisQuestion.IsVisible = compareTwoArrayOfString(
          formattedConditions,
          allQuestionsRelatedValues
        );
      } else {
        thisQuestion.IsVisible = allQuestionsRelatedValues.some(
          (itemQuestionValue) => formattedConditions.includes(itemQuestionValue)
        );
      }
    }
  }
};

export const hasRuleRequired = (question) => {
  const rules = question.Validation?.Rules;
  return rules && rules.length && rules.includes("ruleRequired");
};
